import axiosInstance from './axiosInstance';

export const getLogNames = (password) =>
  axiosInstance.get('/api/v1/admin/logs', {
    headers: { 'X-Logs-Password': password },
  });

export const getLogContent = (name, password) =>
  axiosInstance.get(`/api/v1/admin/logs/${encodeURIComponent(name)}`, {
    headers: { 'X-Logs-Password': password },
  });

export const clearLog = (name, password) =>
  axiosInstance.post(`/api/v1/admin/logs/${encodeURIComponent(name)}/clear`, null, {
    headers: { 'X-Logs-Password': password },
  });
